'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var MerchandiseIds = _interopRequireWildcard(_MerchandiseIds);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = [[MerchandiseIds.PRODUCT_SALES_FREE, MerchandiseIds.PRODUCT_SALES_STARTER, MerchandiseIds.PRODUCT_SALES_PROFESSIONAL, MerchandiseIds.PRODUCT_SALES_ENTERPRISE], [MerchandiseIds.PRODUCT_MARKETING_FREE, MerchandiseIds.PRODUCT_MARKETING_STARTER, MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL, MerchandiseIds.PRODUCT_MARKETING_BASIC, MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL, MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE], [MerchandiseIds.ADDON_WEBSITE_STARTER, MerchandiseIds.ADDON_WEBSITE_UNLIMITED], [MerchandiseIds.PRODUCT_SERVICE_FREE, MerchandiseIds.PRODUCT_SERVICE_STARTER, MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL, MerchandiseIds.PRODUCT_SERVICE_ENTERPRISE]];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/constants/ProductTierOrders.js
// module id = 286
// module chunks = 3 4 5